module.exports = __webpack_public_path__ + "img/0S6A9578.41babc02.jpg";